import React from 'react';
import './Venue.css';

import { venue } from '../../../constants';
import { Heading, Lightbox, PageTitle, VenueDetails } from '../../../components';



const Venue = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Venue'} page={'Venue'} />

      <section className="venue">

        {/* Venue Details Section */}
        <VenueDetails />

        {/* ========== Venue Gallery ========== */}
        <section className="venue-gallery">
          <Lightbox images={venue.venueGallery} /> {/* Lightbox component to handle venue gallery images */}
        </section>

        {/* ========== Venue Features ========== */}
        <div className="venue-features">
          {venue.venueFeatures?.map((feature, index) => (
            <div key={index} className="venue-feature">
              <div className='icon'>{feature.icon}</div> {/* Feature Icon */}
              <h3>{feature.title}</h3> {/* Feature Title */}
              <p>{feature.description}</p> {/* Feature Description */}
            </div>
          ))}
        </div>

        {/* ========== Hotel Rooms ========== */}
        {/* <section className="hotel-rooms">

         
          <Heading title={venue.hotelRooms.heading} subTitle={venue.hotelRooms.sub} />

          <div className="box-container">
            {venue.hotelRooms.rooms.map((room, index) => (
              <div key={index} className="room-item">
                <img src={room.src} alt={room.title} /> 
                <div className="content">
                  <div className="text">
                    <h3>{room.title}</h3>
                    <p>{room.price}</p> 
                  </div>
                </div>
              </div>
            ))}
          </div>

        </section> */}

      </section>

    </>

  );
};

export default Venue;